import {Button, Input, Modal, Spin} from "antd";
import {useCallback, useState} from "react";
import {useFetch, useStore} from "@vigo/hooks";
import React from "react";
import appStore from "store/appStore";

export const UpdateSecretTokenModal = ({supplierId, setRefetch}) => {
    const [visible, setVisible] = useState();
    const [recall, setRecall] = useState(false);
    const stores = useStore();
    useFetch({
        defaultDataValue: [],
        fetchFn: stores.supplierStore.updateSupplierSecret.bind(null, {
            supplierId,
        }),
        initialCall: false,
        showLoading: true,
        dependencies: [recall],
        callbackFunc: (res) => {
            if (res?.data) {
                setVisible(false);
                appStore.openSuccessModal({
                    okText: "Tamam",
                    content: "Seçili tedarikçiye ait yeni key, mail olarak gönderildi."
                });
            }
        }
    });
    const onCancel = useCallback(() => {
        setVisible(false);
    }, []);

    return (
        <div>
            <Modal
                centered
                width={400}
                title={"Secret Keyi Güncelle"}
                visible={visible}
                onCancel={onCancel}
                onOk={() => {
                    setRecall(prev => !prev);
                }}
                okText={"Evet"}
                cancelText={"Hayır"}
            >
                Güncellemek İstediğinizden Emin Misiniz?
            </Modal>
            <Button
                onClick={() => setVisible(true)}
                style={{
                    margin: "8px",
                    color: "white",
                    backgroundColor: "#ffb300",
                    borderColor: "#ffb300"
                }}
            >
                Secret Keyi Güncelle
            </Button>
        </div>
    );
};
